module.exports = __webpack_public_path__ + "img/icon-2_13.ee454cea.png";